/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import { TextField, Grid } from '@mui/material/';
import { grey } from '@mui/material/colors';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import useStyles from '../styles';
import { updateFrom } from '../../../redux/Actions/createInstance.action';
import { ADD_ENV } from '../../../redux/Constants/createInstance.constants';

const ColorButton = styled(Button)(({ theme }) => ({
    color: grey[800],
    border: '1px solid',
    borderColor: 'grey',
    backgroundColor: grey[300],
    lineHeight: 0,
    fontSize: 11,
    width: '97px',
    marginTop: '6px',
    height: '70%',
    justifyContent: 'space-between',
    padding: '2px 10px 2px 2px',
    '&:hover': {
        backgroundColor: grey[400],
        borderColor: 'grey',
        color: theme.palette.getContrastText(grey[400]),
        boxShadow: 'none'
    }
}));

const ColorButtonCross = styled(Button)(() => ({
    color: grey[800],
    border: '0px solid',
    lineHeight: 0,
    fontSize: 11,
    width: '97px !important',
    marginTop: '6px',
    height: '70%',
    justifyContent: 'space-between',
    padding: '2px 17px 2px 2px',
    '&:hover': {
        backgroundColor: 'white',
        border: '0px solid',
        borderColor: 'white'
    }
}));

const MainTextField = styled(TextField)(() => ({
    input: {
        height: '10px'
    }
}));

export default function Environment(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [envDetails, setEnvDetails] = useState({
        prodLink: '',
        serviceLink: '',
        fields: ['']
    });

    const handleChange = (val) => (e) => {
        setEnvDetails({
            ...envDetails,
            [val]: e.target.value
        });

        if (val === 'prodLink' && e.target.value.length !== 0) props.setIsServerUrlError(false);
    };

    const fieldHandleChange = (i, event) => {
        const values = [...envDetails.fields];
        values[i] = event.target.value;
        setEnvDetails({ ...envDetails, fields: values });
    };

    const handleAdd = () => {
        const values = [...envDetails.fields];
        values.push('');
        setEnvDetails({ ...envDetails, fields: values });
    };

    const handleRemove = (i) => {
        const values = [...envDetails.fields];
        values.splice(i, 1);
        setEnvDetails({ ...envDetails, fields: values });
    };

    useEffect(() => {
        dispatch(updateFrom(envDetails, ADD_ENV));
    }, [envDetails]);

    useEffect(() => {
        if (props.val.instances) {
            const data = props.val.instances;
            setEnvDetails({
                prodLink: data.production,
                serviceLink: data.statusPage,
                fields: data.sandbox
            });
        }
    }, [props.val]);

    return (
        <div ref={props.serverUrlRef}>
            <div className={classes.formContainer}>
                <h1 className={classes.heading}>Environment Details</h1>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}>
                            {process.env.REACT_APP_IS_PRODUCTION === 'true'
                                ? 'Production Link'
                                : 'Server Link'}
                        </div>
                        <FormControl fullWidth sx={{ m: 1, paddingRight: '18px' }}>
                            <MainTextField
                                id="outlined-basic"
                                variant="outlined"
                                value={envDetails.prodLink}
                                onChange={handleChange('prodLink')}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                                error={props.isServerUrlError}
                                helperText={props.isServerUrlError && 'Required field'}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <div className={classes.inputHead}>Sandbox Link</div>
                        {/* <FormControl sx={{ width: '100%' }} key="#key1"> */}
                        {/* // width: 'calc(100% + 163px)' */}
                    </Grid>
                    {envDetails.fields.map((field, idx) => (
                        <>
                            <Grid item xs={12} sm={6}>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1, paddingRight: '18px' }}
                                    key={idx}
                                >
                                    {' '}
                                    <div className={classes.mainHeadInstance}>
                                        <MainTextField
                                            className={classes.textBox}
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={field || ''}
                                            onChange={(e) => fieldHandleChange(idx, e)}
                                            InputLabelProps={{
                                                style: { fontSize: '13px' }
                                            }}
                                        />
                                    </div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} className={classes.buttonMargin}>
                                {idx < 1 && (
                                    <div className={classes.iconAdjust}>
                                        <Grid item xs={12} sm={6}>
                                            <ColorButton
                                                variant="outlined"
                                                onClick={() => handleAdd()}
                                            >
                                                <AddIcon />
                                                <p>Add More</p>
                                            </ColorButton>
                                        </Grid>
                                    </div>
                                )}
                                {idx >= 1 && (
                                    <div className={classes.iconAdjust}>
                                        <ColorButtonCross
                                            variant="outlined"
                                            onClick={() => handleRemove(idx)}
                                        >
                                            <ClearIcon className={classes.buttonInnerRemove} />
                                            <p>Remove</p>{' '}
                                        </ColorButtonCross>
                                    </div>
                                )}
                            </Grid>
                        </>
                    ))}
                    {/* </FormControl> */}
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.inputHead}> Service Status Page </div>
                        <FormControl fullWidth sx={{ m: 1, paddingRight: '18px' }}>
                            <MainTextField
                                id="outlined-basic"
                                variant="outlined"
                                value={envDetails.serviceLink}
                                onChange={handleChange('serviceLink')}
                                InputLabelProps={{
                                    style: { fontSize: '13px' }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}
